/**
 * 店舗階層API（FKV3-12590）
 * 店舗階層（店舗ID・店舗名・店舗階層）の一覧を取得
 */

import { apiGet } from './client';
import type { SellerHierarchy } from '@/lib/types';

/**
 * 店舗階層一覧を取得（全店舗）
 */
export async function getSellerHierarchies(
  accountCode: string,
  authHeaders?: Record<string, string>,
): Promise<SellerHierarchy[]> {
  return apiGet<SellerHierarchy[]>(`/${accountCode}/seller-hierarchies`, authHeaders);
}
